module.exports = "/default/images/vendor/lightgallery.js/dist/loading.gif?0aeca8b09888accfccf11976b34c4e64";


//////////////////
// WEBPACK FOOTER
// ./node_modules/lightgallery.js/dist/img/loading.gif
// module id = bc29
// module chunks = 0